
import type { CustomTheme } from '.'

export const customTheme: CustomTheme = {
  colors: {
    primary: {
      DEFAULT: '#cc0033',
      '50': '#ffe5e6',
      '100': '#ffb3b8',
      '200': '#ff8083',
      '300': '#ff4d4f',
      '400': '#ff1a1d',
      '500': '#cc0033',
      '600': '#990025',
      '700': '#660016',
      '800': '#33000e',
      '900': '#1a0006',
    },
    gray: {
      50: '#F8F9FC',
      100: '#EEF1F7',
      200: '#E4E8F0',
      300: '#CCD3DF',
      400: '#A3AABF',
      500: '#748095',
      600: '#4C5567',
      700: '#2E3647',
      800: '#1B202B',
      900: '#181922',
    },
    green: {
      50: '#dff6ed',
      100: '#b0e9d2',
      200: '#76dab6',
      300: '#00cc99',
      400: '#00c083',
      500: '#00b46e',
      600: '#00a463',
      700: '#009255',
      800: '#008048',
      900: '#006131',
    }
  },
  semanticTokens: {
    colors: {
      'chakra-body-text': { _light: 'gray.800', _dark: 'whiteAlpha.900' },
      'chakra-body-bg': { _light: 'white', _dark: 'gray.800' },
      'chakra-border-color': { _light: 'gray.200', _dark: 'whiteAlpha.300' },
      'chakra-placeholder-color': {
        _light: 'gray.500',
        _dark: 'whiteAlpha.400',
      },
      // Badge
      'badge-bg': { default: 'gray.800' },
      // Checkbox
      'checkbox-color': { default: 'gray.800' },
      'checkbox-border': { default: 'gray.500' },
      'checkbox-border-checked': { default: 'white' },
      'checkbox-shadow-color': { default: 'green.700' },
      'checkbox-shadow-highlight-color': { default: 'green.500' },
      // Dashboard
      'dashboard-header-bg': 'gray.900',
      // Form control
      'form-helper-text-color': { default: 'gray.800' },
      // Heading
      'heading-color': { default: 'gray.800' },
      // Input
      'input-bg': 'gray.50',
      'input-border': 'gray.900',
      'input-focused-border': 'gray.900',
      'input-color': 'gray.800',
      // Label
      'label-color': 'gray.800',
      // Menu
      'menu-item-color': 'gray.800',
      // Select
      'select-bg': 'gray.50',
      'select-border': 'gray.900',
      'select-color': 'gray.800',
      'select-icon-color': 'gray.500',
      // Text
      'text-color': 'gray.800',

      // Components
      // Steps
      'steps-container-bg': 'primary.500',
      'step-bg': 'white',
      'step-current-bg': 'primary.500',
      'step-number-border': 'gray.100',
      'step-number-bg': 'transparent',
      'step-number-color': 'gray.100',
      'step-number-passed-bg': 'none',
      'step-number-passed-color': 'white',
      'step-divider-bg': 'gray.600',
      // Steps progress
      'step-progress-passed-bg': 'primary.500',
      // Insurance Info Form Control
      'insurance-info-label-color': 'gray.100',
      'insurance-info-label-bg': 'gray.100',
      'insurance-info-value-color': 'gray.200',
      // Insurance Value
      'insurance-value-border': 'gray.300',
      // Wizzard header
      'wizzard-header-bg': 'gray.800',
      'wizzard-header-history-timeline-dot-bg': 'gray.300',
      'wizzard-header-history-timeline-line-bg': 'gray.700',
      'wizzard-header-history-timeline-label-color': 'gray.200',
      'wizzard-header-history-timeline-user-color': 'gray.200',
      'wizzard-header-history-timeline-description-color': 'gray.300',
      'wizzard-header-history-scrollbar-thumb-color': 'gray.800',
      'wizzard-header-history-scrollbar-track-color': 'gray.600',

      'news-timeline-info-bg': 'gray.200',
      'news-timeline-info-fg': 'gray.600',
      'news-timeline-warn-bg': 'orange.100',
      'news-timeline-warn-fg': 'orange.600',

      'stats-conversion-color': 'primary.500',
    },
  },
  components: {
    Radio: {
      defaultProps: {
        colorScheme: 'primary',
      }
    },
    Slider: {
      defaultProps: {
        colorScheme: 'primary',
      }
    },
    Checkbox: {
      defaultProps: {
        colorScheme: 'primary',
      }
    },
    Switch: {
      defaultProps: {
        colorScheme: 'primary',
      }
    },
  }
}
